// TODO move shared types from Customer to shared
import Status from '../Customer/Status'
import TelecomsAddress from '../shared/Address/TelecomsAddress'

export class Contractor {
  public id: string = ''
  public name: string = ''
  public statuses: Status[] = []
  public identifiers: {
    sitesIdentifiers: string[]
    parentIdentifier?: string
  } = {
      sitesIdentifiers: [],
      parentIdentifier: '',
    }
  public addresses: {
    telecomsAddresses: TelecomsAddress[]
  } = {
      telecomsAddresses: [],
    }
}
export class ContractorPriority {
  public repairPriority: string = ''
}
export enum CatalistTriageContractorType {
  CATALYST_TRIAGE_DEFECT = 'CATALYST_TRIAGE_DEFECT',
  CATALYST_TRIAGE_TIER2 = 'CATALYST_TRIAGE_TIER2',
  CATALYST_TRIAGE_EMA = 'CATALYST_TRIAGE_EMA',
  CONTRACTORSITE_ON_HOLD = 'CONTRACTORSITE_ON_HOLD'
}
export enum EMAContractorType {
  UNKNOWN_EMA_TRIAGE = 'UNKNOWN_EMA_TRIAGE',
  EMA_UNKNOWN_CONTACTDETAILS_TRIAGE = 'EMA_UNKNOWN_CONTACTDETAILS_TRIAGE',
  CATALYST_TRIAGE_EMA = 'CATALYST_TRIAGE_EMA'
}